/* vb-io-video — lazy-load + autoplay/pause <video.vb-autoplay-video> via
   IntersectionObserver. Sources carry data-src so nothing downloads until
   the video nears the viewport. No-op under prefers-reduced-motion
   (CSS also hides the videos, leaving posters). */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (!video.dataset.vbLoaded) {
            video.querySelectorAll('source[data-src]').forEach(function (s) {
              s.src = s.dataset.src;
            });
            video.load();
            video.dataset.vbLoaded = '1';
          }
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (video.dataset.vbLoaded) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px 200px 0px' }
  );

  function observeAll(root) {
    (root || document).querySelectorAll('video.vb-autoplay-video').forEach(function (v) {
      io.observe(v);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  /* Theme-editor support: re-observe videos in re-rendered sections */
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
})();
